import React, { useState } from 'react';

const DedicationSection = ({ dedicationEnabled, setDedicationEnabled, dedicationOptions, setDedicationOptions }) => {
  const [newDedicationOption, setNewDedicationOption] = useState('');

  return (
    <div className="gc-section">
      <div className="gc-section-row">
        <div className="gc-section-info">
          <h3 className="gc-section-title">Gift Dedication</h3>
          <p className="gc-section-desc">Allow donors to dedicate their gifts in honor or memory of someone.</p>
        </div>
        <div className="gc-section-fields">
          <div className="gc-field">
            <label className="gc-checkbox-label">
              <input
                type="checkbox"
                className="gc-checkbox"
                checked={dedicationEnabled}
                onChange={() => setDedicationEnabled(!dedicationEnabled)}
              />
              Enable gift dedication
            </label>
            <div className="gc-hint">When enabled, donors can dedicate their gift in honor or memory of someone.</div>
          </div>

          {dedicationEnabled && (
            <div className="gc-field">
              <label className="gc-label">Dedication Types</label>
              <div className="gc-dedication-options">
                {dedicationOptions.map((opt, i) => (
                  <div key={i} className="gc-dedication-option-row">
                    <input
                      type="text"
                      className="gc-input"
                      value={opt}
                      onChange={(e) => {
                        const updated = [...dedicationOptions];
                        updated[i] = e.target.value;
                        setDedicationOptions(updated);
                      }}
                    />
                    <button
                      type="button"
                      className="gc-amounts-delete"
                      onClick={() => setDedicationOptions(dedicationOptions.filter((_, idx) => idx !== i))}
                      title="Remove option"
                    >
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M18 6L6 18M6 6L18 18" />
                      </svg>
                    </button>
                  </div>
                ))}
              </div>
              <div className="gc-dedication-add-row">
                <input
                  type="text"
                  className="gc-input"
                  placeholder="Add a dedication type..."
                  value={newDedicationOption}
                  onChange={(e) => setNewDedicationOption(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && newDedicationOption.trim()) {
                      e.preventDefault();
                      setDedicationOptions([...dedicationOptions, newDedicationOption.trim()]);
                      setNewDedicationOption('');
                    }
                  }}
                />
                <button
                  type="button"
                  className="btn btn-setlist-secondary btn-sm"
                  disabled={!newDedicationOption.trim()}
                  onClick={() => {
                    if (newDedicationOption.trim()) {
                      setDedicationOptions([...dedicationOptions, newDedicationOption.trim()]);
                      setNewDedicationOption('');
                    }
                  }}
                >
                  Add
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DedicationSection;
